// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Recognition40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Recognition40: FC<Recognition40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M30.6 15.764c0-5.854-4.746-10.6-10.6-10.6-5.854 0-10.6 4.746-10.6 10.6 0 5.854 4.746 10.6 10.6 10.6 5.854 0 10.6-4.746 10.6-10.6Zm-2.237 10.468a13.334 13.334 0 0 1-6.474 2.798l2.396 4.15 2.32-2.988 3.747-.516-1.989-3.444ZM9.648 29.676l3.748.516 2.318 2.987 2.396-4.15a13.336 13.336 0 0 1-6.474-2.796l-1.988 3.443Zm17.021-16.55-8.473 8.472-5.214-5.216 1.98-1.98 3.234 3.236 6.493-6.492 1.98 1.98Zm6.73 2.638c0 3.193-1.117 6.125-2.982 8.427l4.444 7.694-6.745.925-4.172 5.378-3.945-6.831-3.943 6.831-4.173-5.378-6.743-.925 4.441-7.694A13.344 13.344 0 0 1 6.6 15.764c0-7.4 6-13.4 13.4-13.4s13.4 6 13.4 13.4Z" />
        </svg>
    );
};

export default Recognition40;
